import { render, staticRenderFns } from "./CNotificationsList.vue?vue&type=template&id=c122a2de&scoped=true&"
import script from "./CNotificationsList.vue?vue&type=script&lang=ts&"
export * from "./CNotificationsList.vue?vue&type=script&lang=ts&"
import style0 from "./CNotificationsList.vue?vue&type=style&index=0&id=c122a2de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c122a2de",
  null
  
)

export default component.exports